<style lang="scss" scoped>
.dropdown {
    opacity: 0;
    transition: opacity 0.2s;
    position: absolute;
    top: 100%;
    right: 0;
    pointer-events: none;

    .dropdown-inner {
        border-radius: 2px;
        background-color: #ffffff;
        box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.08);
        min-width: 300px;
        display: flex;
        flex-direction: column;
    }

    &.active {
        opacity: 1;
        pointer-events: all;

        &:after {
            opacity: 1;
        }
    }
}
</style>

<template>
    <div class="dropdown-link relative" @mouseover="hover = true" @mouseleave="hover = false">
        <a :href="href" :class="linkClasses">{{ name }}<span v-if="hasDefaultSlot" class="text-12 inline-block ml-8">▾</span></a>
        <div class="dropdown pt-16" :class="{ active: hover && hasDefaultSlot }">
            <div class="dropdown-inner py-8">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Ui.DropdownLink",

    data() {
        return {
            hover: false
        };
    },

    props: {
        href: {
            type: String,
            required: true
        },

        name: {
            type: String,
            required: true
        },

        linkClasses: {
            type: String,
            required: false,
            default: ""
        }
    },

    computed: {
        hasDefaultSlot() {
            return !!this.$slots.default;
        }
    }
};
</script>
